import axios from "../../../axios";

export const getSchedules = async () => {
  try {
    let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/schedule`);
    return data;
  } catch (e) {
    console.log("e",e)
  }
};
